// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/sass/demo.scss
// module id = 9G8F
// module chunks = 6